import { toast as soonerToast } from "sonner";

const toast = ({
  type = "success",
  message,
}: {
  type?: "error" | "warn" | "success";
  message: string | React.ReactNode;
}) => {
  if (type == "error") {
    return soonerToast.error(message, {
      className: "!bg-red-500 !text-white",
    });
  }

  if (type == "warn") {
    return soonerToast.warning(message, {
      className: "!bg-yellow-600 !text-white",
    });
  }

  if (type == "success") {
    return soonerToast.success(message, {
      className: "!bg-green-600 !text-white",
    });
  }
};

export default toast;
